import SelectedPassengerClass from "@CheckOrder/features/classPicker/components/SelectedPassengerClass";
import TripleDotLoader from "@Generic/loaders/TripleDotLoader";
import PassengerClassesGroup from "@CheckOrder/features/classPicker/components/PassengerClassesGroup";
import DropdownButton from "@Generic/buttons/DropdownButton";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";
import useHandlePassengerClassSelect from "@CheckOrder/features/classPicker/hooks/useHandlePassengerClassSelect";
import AvailablePassengerClassesGroupType
    from "@CheckOrder/features/classPicker/types/AvailablePassengerClassesGroup.type";
import useColorCodeUsersInTheSamePassengerGroup
    from "@CheckOrder/features/classPicker/hooks/useColorCodeUsersInTheSamePassengerGroup";

interface ClassPickerDropdownProps {
    passengerId: number,
    availablePassengerClassesGroups: AvailablePassengerClassesGroupType[],
    selectedPassengerClass: AvailablePassengerClassType,
    setSelectedPassengerClass: (value: AvailablePassengerClassType) => void,
    setNewlySelectedPassengerClass: (value: AvailablePassengerClassType) => void,
    isReturn?: boolean,
    showSelectedClassDetails?: boolean,
}

function ClassPickerDropdown(props: ClassPickerDropdownProps) {
    const {
        passengerId,
        availablePassengerClassesGroups,
        selectedPassengerClass,
        setSelectedPassengerClass,
        setNewlySelectedPassengerClass,
        isReturn,
        showSelectedClassDetails,
    } = props

    const {
        colorCodedClassName,
        colorCodedStyle,
    } = useColorCodeUsersInTheSamePassengerGroup(selectedPassengerClass, passengerId, isReturn)

    const {
        handlePassengerClassSelect,
    } = useHandlePassengerClassSelect(passengerId, setSelectedPassengerClass, setNewlySelectedPassengerClass, isReturn)

    return (
        <DropdownButton
            baseClass="gb--select"
            cssLabelClass="gb--select-dropdown gb--select-dropdown-btn passenger-class__select"
            cssButtonClass={`gb--select-dropdown-label passenger-class__select-wrapper ${colorCodedClassName}`}
            style={colorCodedStyle}
            label={selectedPassengerClass ? (
                <SelectedPassengerClass
                    selectedPassengerClass={selectedPassengerClass}
                    passengerId={passengerId}
                    isReturn={isReturn}
                    showDetails={showSelectedClassDetails}
                />
            ) : (
                <TripleDotLoader small/>
            )}
        >
            <div className="react-autosuggest__suggestions-list">
                {availablePassengerClassesGroups.map((passengerClassesGroup) => (
                    <PassengerClassesGroup
                        key={`${passengerClassesGroup.availablePassengerClasses[0]?.groupId}-${passengerClassesGroup.availablePassengerClasses[0]?.id}`}
                        passengerId={passengerId}
                        passengerClassesGroup={passengerClassesGroup}
                        handlePassengerClassSelect={handlePassengerClassSelect}
                        isReturn={isReturn}
                    />
                ))}
            </div>
        </DropdownButton>
    )
}

export default ClassPickerDropdown